import { create } from 'zustand';

interface NavState {
  current: string;
  setCurrent: (name: string) => void;
}

export const useNav = create<NavState>((set) => ({
  current: 'Dashboard',
  setCurrent: (name) => set({ current: name }),
}));
